interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = "" }) => {
  return (
    <div className={`bg-bg-primary rounded shadow-md p-6 ${className}`}>
      {children}
    </div>
  );
};
